import { render, staticRenderFns } from "./TemplateModulesPage.vue?vue&type=template&id=dabc3ae2&"
import script from "./TemplateModulesPage.vue?vue&type=script&lang=js&"
export * from "./TemplateModulesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports